exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "mat-panel-title {\r\n  font-size: 1rem;\r\n  line-height:2rem;\r\n  font-weight: bold;\r\n}\r\n\r\np {\r\n  max-width:35em;\r\n}\r\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Users/EricChanney/Apps/nexpress-angular-site/src/app/component/frequently-asked-questions/frequently-asked-questions.component.css
// module id = ../../../../../src/app/component/frequently-asked-questions/frequently-asked-questions.component.css
// module chunks = main